import Box from "@material-ui/core/Box";
import EditIcon from "@material-ui/icons/Edit";
export const getMaintenanceColumns = (editData) => {
  const columns = [
    {
      dataField: "OP2",
      text: "",
      //sort: true,

      // events: onClickCol,
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <EditIcon
              color="action"
              onClick={() => {
                editData(row);
              }}
            />
          </Box>
        );
      },
    },
    {
      dataField: "ROLE_ID",
      text: "Role ID",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "ModuleText",
      text: "Modules",
      sort: true,
      headerAlign: 'center',
    },
  ];
  return columns;
};
